<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${roleTypeId ? 'Edit' : 'Add New'} Role Type (Employee, Controller, Partner, Third Party)
`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="roleTypeId" class="custom-label">ID</label>
            <input id="roleTypeId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" rows="4" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.roleTypeId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>

        <!-- Modal -->
        <deleteModal v-if="this.roleTypeId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.roleTypeId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button"
              @click="addRoleTypeData()">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addRoleType, getByIdRoleType, updateRoleType } from '@/http/user-mgmt/role-type.http'
import deleteModal from '@/components/delete-modal.vue';
export default {
  name: 'asset-type-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      // titleConfig:"Add Asset Type",
      roleTypeId: this.$route.params.id,
      saveData: {},
      breadcrumsfirst: "User Management",
      breadcrumslast: "Role Type",

    }
  },
  mounted() {
    if (this.roleTypeId) {
      getByIdRoleType(this.$route.params.id).then((res) => {
        this.saveData = res
      }).catch((error)=>{
        console.log('Error fetching Role Type:', error)
      })
    }
  },
  methods: {
    addRoleTypeData() {
      if (this.roleTypeId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateRoleType({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/usermanagement/roletype")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addRoleType(this.saveData).then(() => {
          this.$router.push("/usermanagement/roletype")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    cancelButton() {
      this.$router.push("/usermanagement/roletype")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateRoleType({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/usermanagement/roletype")
      }).catch((error) => {
          this.error = error.message;
      });

    },

  }
}
</script>

<style scoped></style>